const theme = {
  colors: {
    success: '#8bc34a',
    error: '#E91E63',
    info: '#2196f3',
    warning: '#ffeb3b',
  },
  palette: {
    // Brand colors
    primary: { main: '#FF6E3D', contrastText: '#333' },
    secondary: { main: '#1C0C1D', contrastText: '#333' },
    background: { main: '#FFFFFF', contrastText: '#333' },
    surface: { main: '#FFFFFF', contrastText: '#333' },
    error: { main: '#E91E63', contrastText: '#FFFFFF' },
  },
};

export default theme;
